import React, { useEffect } from 'react'
import Validation from '../../../../../Helper/validations/vaildation';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import labController from '../../../../../../apis/Controllers/LabController/lab.controller';
const AddReportFunction = () => {
    const defaultValues = {
        testType: "",
        testName: "",
        test: [{
            testCategory: "",
            range: "",
            error_test: false,
            error_range:false
        }],
        file:[]
    }
    const defaultErrors = {
        testType: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        testName: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        test: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        file: {
             rules: [""],
            isValid: true,
            message: "",
        }
    };

    const [values, setValues] = useState(defaultValues);
    const [isError, setError] = useState(defaultErrors);
    const [loader, setLoader] = useState(false);
    const [testTyleList, setTestTypeList] = useState([]);
    const [testNameList, setTestNameList] = useState([]);
    const [testCategoryList , setTestCategoryList] = useState([])
    const loaction = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (values && values.testType) {
            getTestNameListing();
        }
    }, [values.testType]);

    useEffect(() => {
          if(values && values.testName) {
            getTestCategoryListing();
        }
    }, [values.testName])
    
    useEffect(() => {
        getSubCategoryListing();
    },[values && values.test])
    
    const handleChange = (field, value) => {
        let validation = new Validation(isError);
        let node = validation.validateField(field, value);
        setError({ ...isError, [field]: node });
        setValues({ ...values, [field]: value });
    };
    
     const handleChange1 = (index, field, value) => {
        const updatedtest = [...values.test];
         updatedtest[index][field] = value;
         if (field == "testCategory") {
            if (updatedtest[index][field] == "" || null || undefined) {
            let err = true;
            values.test[index].error_test = err;
         } else {
            let err = false;
            values.test[index].error_test = err;
            }   
         } else {
            if (updatedtest[index][field] == "" || null || undefined) {
            let err = true;
            values.test[index].error_range = err;
         } else {
            let err = false;
            values.test[index].error_range = err;
        }   
        }
        setValues({...values , test : updatedtest})
    };
    
    const addCategories = () => {
       const test = {
                testCategory: "",
                range: ""
              }
        const arr = [...values.test , test];
        setValues({...values , test:arr})
    }

    const deleteCategories =(item) => {
        let arr = [...values.test];
        if (item) {
                let index = arr.indexOf(item);
                if (index > -1) {
                    arr.splice(index,1)
               };
        setValues({...values , test:arr})
        }
    }


    const getTestTypeListing = async () => {
        let response = await labController.testTypeListing()
        if (response && response.status) {
            let array = response.data;
            for (let i in array) {
                array[i]["label"] = array[i].title;
            }
            setTestTypeList(array)
        } else {
            setTestTypeList([])
        }
    };

    const getTestNameListing = async() => {
        let response = await labController.testNameListing( values && values.testType)
        if (response && response.status) {
            let array = response.data;
            for (let i in array) {
                array[i]["label"] = array[i].title;
            }
            setTestNameList(array)
        } else {
            setTestNameList([])
        }
    }

    const getTestCategoryListing = async () => {
        let response = await labController.testCategoryListing( values && values.testName)
        if (response && response.status) {
            let array = response.data;
            for (let i in array) {
                array[i]["label"] = array[i].title;
            }
            setTestCategoryList(array)
        } else {
            setTestCategoryList([])
        }
    }

    const getSubCategoryListing = async () => {
        let response = await labController.subCategoryListing(values && values.test)
        if (response && response.status) {
            let array = response.data;
            for (let i in array) {
                array[i]["label"] = array[i].title;
            }
            setTestCategoryList(array)
        } else {
            setTestCategoryList([])
        }
    };
     
    const submitReport = async () => {
        let array = [...values.test];
        if (values && values.test) {
            for (let i in array) {
                if (array[i].testCategory == "" || null || undefined) {
                    array[i].error_test = true;
                }
                if(array[i].range == "" || null || undefined){
                    array[i].error_range = true;
                }
             }
        };
        let validation = new Validation(isError);
        let isValid = validation.isFormValid(values);
        if (isValid && !isValid.haveError) {
            setLoader(true);
                // let response = await labController.bedsUpdate(id, values);
                // if (response && response.status) {
                //     new Toaster().success(response.message);
                //     // navigate('', { replace: true });
                //     setLoader(false);
                // } else {
                //     setLoader(false);
                // }
        } else {
            setError({ ...isValid.errors });
        }
    };
    
    console.log(values && values.test, "<<====Res=======");
    
    return {
        values,
        loader,
        isError,
        loaction,
        navigate,
        handleChange,
        submitReport,
        addCategories,
        deleteCategories,
        handleChange1,
        getTestTypeListing,
        testTyleList,
        testNameList,
        testCategoryList
  }
}

export default AddReportFunction